//
/** Provided for your convenience. */
class Utilities {
  constructor(global) {
    this.global = global;
  }
  /**
   * Returns true if the client is Windows 8
   * @return {Boolean}
   */
  isWindowsMobile() {
    return !!(window.external && window.external.notify);
  }
  /**
   * Returns true if we are in an online vs. offline environment
   * @return {Boolean}
   */
  isOnline() {
    return !!window.postMessage;
  }
  /**
   * Returns true if we are in the ios app
   * @return {Boolean}
   */
  isIOS() {
    return !!window.webkit;
  }
  /**
   * Merge two objects with the first parameter having priority over the second unless clobber is true;
   * @param  {object} dst Source of truth object to which to add members from src object.
   * @param  {object} src Object from which to copy members to dst
   * @param  {boolean} [clobber=false] Boolean to indicate if src members should override dst members.
   * @return {object}
   */
  mergeObjects(dst, src, clobber = false) {
    const srcKeys = Object.keys(src);
    let key;
    const destination = this.copyObject(dst);
    while ((key = srcKeys.pop())) {
      if ((!clobber && !dst[key]) || clobber) {
        destination[key] = src[key];
      }
    }
    return destination;
  }
  /**
   * @param  {Object} obj Object to copy
   * @return {Object}
   */
  copyObject(obj) {
    return JSON.parse(JSON.stringify(obj));
  }
  /**
   * @param  {Object} originalObject The object to copy.
   * @return {Object}
   */
  deepCopy(originalObject) {
    if (originalObject === null || typeof originalObject !== 'object') {
      return originalObject;
    }

    let clonedObject;
    if (originalObject instanceof Date) {
      clonedObject = new Date(originalObject);
    } else {
      clonedObject = originalObject.constructor();
    }
    const origObjKeys = Object.keys(originalObject);
    let origObjKey;
    while ((origObjKey = origObjKeys.pop())) {
      // TODO: worse case O(2^n), any better?
      clonedObject[origObjKey] = this.deepCopy(originalObject[origObjKey]);
    }

    return clonedObject;
  }
  /**
   * @param  {String} whereClause
   * @param  {String} input String to use in place of stringToBeReplaced
   * @param  {String} stringToBeReplaced The string to replace with the input.
   * @return {String}
   */
  replaceStringInWhereClause(whereClause, input, stringToBeReplaced) {
    let result = '';

    let i;
    const indices = this.getIndicesOf(stringToBeReplaced, whereClause);

    if (indices.length === 0) {
      return whereClause;
    }

    for (i = 0; i < indices.length; i += 1) {
      if (i === 0) {
        result += whereClause.slice(0, indices[0]);
      } else {
        result += whereClause.slice(indices[i - 1] + stringToBeReplaced.length, indices[i]);
      }

      result += `'${input}'`;
    }

    result += whereClause.slice(indices[indices.length - 1] + stringToBeReplaced.length);

    return result;
  }
  /**
   * @param  {String}
   * @param  {String}
   * @param  {Boolean}
   * @return {Array}
   * @private
   */
  getIndicesOf(search, source, caseSensitive) {
    let sourceStr = source;
    let searchStr = search;
    const indices = [];
    const searchStrLen = searchStr.length;

    if (searchStrLen) {
      if (!caseSensitive) {
        sourceStr = sourceStr.toLowerCase();
        searchStr = searchStr.toLowerCase();
      }

      let startIndex = 0;
      let index;
      while ((index = sourceStr.indexOf(searchStr, startIndex)) > -1) {
        indices.push(index);
        startIndex = index + searchStrLen;
      }
    }

    return indices;
  }
}
export default Utilities;
